import Css from './Customer.module.css';
import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function NavStep2({ stepPage = 1, quontationName }) {
    const navigate = useNavigate();

    const arr_images_step = [
        { seq: 1, name: 'รอจัดทำใบแจ้งหนี้', img: 'Group 2297.png' }
        , { seq: 2, name: 'รอตรวจสอบ/ จัดทำใบเสร็จ', img: 'Group 2332.png' }
        , { seq: 3, name: 'รอเอกสารหัก ณ ที่จ่าย', img: 'Group 2311.png' }
        , { seq: 4, name: 'เสร็จสมบูรณ์', img: 'Group 2325.png' }
    ]

    const [step, setStep] = useState(stepPage);
    useEffect(() => {
        setStep(stepPage);
    }, [stepPage])
    const getStepSelectClass = (seq) => {
        return (seq == step) ? Css.active : '';
    }

    return (
        <div className={`mb-2 mt-3 ${Css.Nav_step}`}>
            <ul className={Css.progressbar}>
                {
                    arr_images_step.map((obj, index) => (
                        <li key={index} className={getStepSelectClass(obj.seq)}>
                            <span>{obj.name}</span>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}